import JsBarcode from 'jsbarcode';
import { DOMImplementation, XMLSerializer } from 'xmldom';

// DOC
// https://pdfmake.github.io/docs/0.1/document-definition-object/qr/

export class ImpressaoEtiqueta {

  constructor(dadosParaImpressao) {
    this.dadosParaImpressao = dadosParaImpressao;
  }

  async PreparaDocumento() {
    const corpoDocumento = this.CriaCorpoDocumento(this.dadosParaImpressao);
    const documento = this.GerarDocumento(corpoDocumento);
    return documento;
  }

  CriaCorpoDocumento() {
    return this.dadosParaImpressao.moldsWagon.map(({ mold, piece }) => {
      const getMold = this.dadosParaImpressao.wagon.isagA_Vagoes_Fornos_Pecas
        .some(w => w.ordem_Serial === piece.ordem_Serial && !w.ativo)

      if (getMold)
        return []
      if (mold.molde_SAPLocal === "NÃO CADASTRADO")
        return []

      const contentMold = [[
        { text: mold.molde_Lote, fontSize: 20, },
        { text: mold.molde_SAPLocal, fontSize: 20, margin: [30, 0, 0, 5] },
      ]]

      const headerWagon = [
        { text: 'Vagão', bold: true, fontSize: 6, margin: [0, 0, 0, 0] },
        { text: 'Forno', bold: true, fontSize: 6, margin: [0, 0, 0, 0] },
        {}
      ];

      const bodyWagon = [[
        { text: this.dadosParaImpressao.wagon.vagao_Serial, fontSize: 6 },
        { text: this.dadosParaImpressao.typesPiecesCombinations.forno, fontSize: 6 },
        {}
      ]];

      const lineHeadercolSpanWagon = [
        {
          text:
            '___________________________________________________________________________________________________________________________________________________________________________________________',
          alignment: 'center',
          fontSize: 3,
          colSpan: 2
        },
        {},
        {},
      ];

      let contentWagon = [headerWagon, lineHeadercolSpanWagon];
      contentWagon = [...contentWagon, ...bodyWagon];

      const xmlSerializer = new XMLSerializer();
      const document = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
      const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

      const code = mold.molde_SAPLocal !== "NÃO CADASTRADO"
        ? `${this.dadosParaImpressao.wagon.vagao_Key}.${mold.molde_Key}.${piece.ordem_Serial}`
        : "00000000"

      JsBarcode(svgNode, code, {
        xmlDocument: document,
        width: .8,
        height: 25,
        fontSize: 5
        // displayValue: false
      });

      const svgText = xmlSerializer.serializeToString(svgNode);

      return [
        {
          layout: 'noBorders',
          headerRows: 1,
          widths: ['*'],
          table: {
            body: contentMold
          },
        },
        { text: mold.molde_Codigo, fontSize: 10, margin: [0, 0, 0, 2] },
        { text: mold.molde_Descricao, fontSize: 10, margin: [0, 0, 0, 2] },
        {
          layout: 'noBorders',
          headerRows: 1,
          widths: ['*'],
          table: {
            body: contentWagon
          },
        },
        {
          svg: svgText,
          style: 'image',
        },
        // { qr: 'text in QR' },
      ];
    });
  }

  GerarDocumento(content) {
    const documento = {
      pageSize: 'A4',
      pageMargins: [0, 0, 0, 0],
      pageOrientation: 'landscape',
      content: content,
      styles: {
        image: {
          margin: [30, 0, 0, 500],
          // alignment: 'center'
        }
      },
    };

    return documento;
  }
}
